import React, { useState } from 'react'
import { useLayoutHeader } from 'components/MainLayout'
import { Button, Input, Row, Typography } from "antd";
import './VehicleCode.css'
const { Title, Paragraph } = Typography;


const headerConfig = {
    pageTitle: "کد اسکوتر",
    closeable: true,
    menuEnabled: false,
}

export default function StartRideView(props) {
    const { onStartRide } = props
    useLayoutHeader(headerConfig)
    const [vehicleCode, setVehicleCode] = useState(undefined)
    return <React.Fragment>
        <React.Fragment>
            <Row>
                <Title level={1}> شروع سفر </Title>
            </Row>
            <Row>
                <Paragraph>کد اسکوتر را برای شروع سفر وارد کنید</Paragraph>
            </Row>
            <Row>
                <Input className='button-code' value={vehicleCode} onChange={value => setVehicleCode(value)} />
            </Row>
            <Row justify="center">
                <Button
                    className='button-code'
                    type="primary"
                    shape="round"
                    onClick={event => vehicleCode && onStartRide && onStartRide(vehicleCode)}
                >شروع سفر</Button>
            </Row>
        </React.Fragment>

    </React.Fragment>
}
